import { defaultDateFormatter, defaultDateTimeFormatter, defaultTimeFormatter } from "@cp/shared/lib";
import { format, isValid, parse } from 'date-fns';
import { DateTimePickerProps } from "./model";
import { DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT, DATE_TIME_PICKER_VALUE_DATE_FORMAT_DEFAULT, TIME_PICKER_VALUE_DATE_FORMAT_DEFAULT } from "./const";

/**
 * Converts value to Date object
 */
export const prepareValue = (_value: string | Date | undefined, valueDateFormat: DateTimePickerProps['valueDateFormat']): Date | null => {
  let value: Date | null = null;

  if (_value) {
    if (typeof _value === 'string') {
      value = typeof valueDateFormat === 'string' ? parse(_value, valueDateFormat, new Date()) : new Date(_value);
    } else if (_value instanceof Date) {
      value = _value;
    }
  }

  return isValid(value) ? value : null;
};

/**
 * Gets formatter for date display based on picker type
 */
export const getDefaultLabelDateFormat = (pickerType: DateTimePickerProps['pickerType']): string | ((date: Date) => string) => {
  switch (pickerType) {
    case 'dateTime':
      return defaultDateTimeFormatter;
    case 'time':
      return defaultTimeFormatter;
    case 'date':
    default:
      return defaultDateFormatter;
  }
};

/**
 * Gets date value format based on picker type
 */
export const getDefaultValueDateFormat = (pickerType: DateTimePickerProps['pickerType']): string => {
  switch (pickerType) {
    case 'dateTime':
      return DATE_TIME_PICKER_VALUE_DATE_FORMAT_DEFAULT;
    case 'time':
      return TIME_PICKER_VALUE_DATE_FORMAT_DEFAULT;
    case 'date':
    default:
      return DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT;
  }
};

/**
 * Formats date value for onChange callback
 */
export const formatValueForOnChange = (value: Date | null, valueDateFormat: DateTimePickerProps['valueDateFormat']): string | Date | undefined => {
  if (!value || !(value instanceof Date)) {
    return undefined;
  }

  return valueDateFormat ? format(value, valueDateFormat) : value;
};